import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { HotTour } from 'shared/api/tours/search'
import { priceShow } from 'shared/lib/priceShow.ts'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  tour?: HotTour
  onClick: (tourId?: HotTour) => void
}

export const HotTourCardMini = ({ tour, onClick }: Props) => {
  const { t } = useTranslation()

  const titleText = `${tour?.countryname || ''}, ${tour?.hotelname || ''}`
  const passengerCount = tour?.adults || 1
  const nightsCount = tour?.nights || 0

  const nightsText = t('tours_block.night', { count: nightsCount })
  const passengersText = t('tours_block.tourist', { count: passengerCount })
  const subtitleText = t('tours_block.hot_tour_subtitle', {
    nights: nightsText,
    passengers: passengersText,
  })

  return (
    <div
      className={s.container}
      onClick={() => onClick(tour)}
    >
      <ImageLazy
        src={tour?.hotelpicture}
        className={s.image}
      />

      <div className={s.info}>
        <div className={s.titles}>
          <p className={clsx('semi-bold-14', s.title)}>{titleText}</p>
          <p className={clsx('regular-12', s.subtitle)}>{subtitleText}</p>
        </div>

        <div className={s.price}>
          <p className={clsx('extra-bold-14', s.som)}>
            {`${t('price_start', { price: priceShow(String(tour?.price || 0)) })}`}
          </p>

          {tour?.price_usd && (
            <p className={clsx('semi-bold-12', s.dollar)}>
              (~&#36;
              {priceShow(String(Math.ceil(Number(tour?.price_usd || 0))))})
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
